import { style } from '@vanilla-extract/css';

export const htmlSnippet = style({
  padding: '4px var(--wt-padding)',
  whiteSpace: 'normal',
  overflowWrap: 'normal',
});
